
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import { Container } from "inversify";
import OrganizationTransactions from "../molecules/transactions/OrganizationTransactions.vue";
import { MergerAcquisitionsListStore } from "../stores/mergerAcquisitions/MergerAcquisitionsListStore";
import { OrganizationMergerAcquisitionsListStore } from "../stores/mergerAcquisitions/OrganizationMergerAcquisitionsListStore";
import { handleError } from "../../../common/src/utility/errorUtils";
import TransactionTable from "../molecules/transactions/TransactionTable.vue";
import { debounce } from "@fullcalendar/core";
import { MergerAcquisitionsCollectionStore } from "../stores/mergerAcquisitions/MergerAcquisitionsCollectionStore";

@Component({
    components: {
        OrganizationTransactions,
        TransactionTable,
    },
})
export default class TransactionsView extends Vue {
    @Inject("container") readonly container!: Container;
    readonly mergerAcquisitionsListStore: MergerAcquisitionsListStore = this.container.get(
        MergerAcquisitionsListStore,
    );

    readonly mergerAcquisitionsCollectionStore: MergerAcquisitionsCollectionStore =
        this.container.get(MergerAcquisitionsCollectionStore);

    readonly organizationMergerAcquisitionsListStore: OrganizationMergerAcquisitionsListStore =
        this.container.get(OrganizationMergerAcquisitionsListStore);

    isOrgView = false;

    created() {
        this.mergerAcquisitionsListStore.load();

        if (!this.isOrgView) {
            if (this.mergerAcquisitionsListStore.organizationId) {
                this.reload();
            }
        }
    }

    orgViewClicked() {
        this.isOrgView = true;
        this.organizationMergerAcquisitionsListStore.load().catch(handleError);
    }

    tableViewClicked() {
        this.isOrgView = false;
        this.mergerAcquisitionsListStore.load().catch(handleError);
    }

    @Watch("mergerAcquisitionsListStore.query")
    @Watch("organizationMergerAcquisitionsListStore.query")
    @Watch("mergerAcquisitionsListStore.generalTransactionType")
    reloadDebounce = debounce(this.reload, 300);

    search(input: any) {
        this.mergerAcquisitionsListStore.query = input.target.value;
        this.organizationMergerAcquisitionsListStore.query = input.target.value;
    }

    reload() {
        this.mergerAcquisitionsListStore.clear();
        this.mergerAcquisitionsListStore.organizationId = undefined;
        this.organizationMergerAcquisitionsListStore.clear();

        this.mergerAcquisitionsListStore.reload().catch(handleError);
        this.organizationMergerAcquisitionsListStore.reload().catch(handleError);
    }
}
